/*
  Copyright 2018 Experian. All Rights Reserved
*/

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { resources } from './resources';

export const environment = Object.assign({}, {
  production: true,
  local: false,
  clientId: '5d6ebf3ba790df000adcc259',
  basePathAccount: 'https://api.serasaexperian.com.br/cross-domain/account/v1',
  basePathIam: 'https://api.serasaexperian.com.br/security/iam/v1',
  dtmScriptURL_v2: '//assets.adobedtm.com/launch-ENf5da77545f2c4a8c9cbabb70d2b5c59a.min.js',
  basePathOrquestrador: 'https://api.serasaexperian.com.br/data-capture/orquestrador/v1',
  basePathOrdens: 'https://experian-serasajud-oficio-api.prod-do.br.experian.eeca/serasajud-oficio/v1',
  basePathEauthIdentific: 'https://identific.certificadodigital.com.br/api/v2',
  identificAppID: '',
  identificApiKey: '',

  featureToggle: {
    validations: {
      accessToken: {
        expireDate: true
      }
    },
    errorHandler: {
      error401: true
    }
  },
  braspag: {
    environment: 'production'
  },
}, resources);
